<template>
  <div>
    <el-row :gutter="20" style="margin-left: 5px;" type="flex">
      <el-col :span="8"
        ><el-input placeholder="Search by Field ID / Farmer ID / Farmer Name " prefix-icon="el-icon-search" v-model="filters.searchString">
        </el-input>
      </el-col>
      <el-col :span="3.5">
        <el-button type="primary" icon="el-icon-refresh" @click="dialogs.reassign = true">Reassign</el-button>
      </el-col>
      <el-col :span="3.5" :offset="6">
        <p class="mt-2">{{ itemsShowing }}</p>
      </el-col>
    </el-row>
    <el-table
      ref="elTable"
      :data="filteredData"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      style="width: 99%; margin-left: 5px;"
      border
      size="small"
      :header-cell-style="{ background: '#f1f1f5', color: 'black', textAlign: 'center' }"
    >
      <el-table-column type="selection" width="35" :reserve-selection="true" />
      <!-- <el-table-column label="S.No" type="index" align="center" min-width="40" fixed /> -->
      <el-table-column property="farm_id" label="Field ID" align="center" min-width="100" fixed />
      <el-table-column property="farmer_id" label="Farmer ID" align="center" min-width="100" />
      <el-table-column property="farmer" label="Farmer" align="center" min-width="180" />
      <el-table-column
        property="district"
        label="District"
        align="center"
        :filters="filters.districts"
        :filter-method="filterHandler"
        min-width="180"
      />
      <el-table-column
        property="village"
        label="Village"
        align="center"
        :filters="filters.villages"
        :filter-method="filterHandler"
        min-width="180"
      />
      <el-table-column property="acre" label="Acre" align="center" min-width="70" />
      <el-table-column
        property="cultivation_variety"
        label="Variety"
        align="center"
        :filters="filters.variety"
        :filter-method="filterHandler"
        min-width="180"
      />
      <el-table-column property="pin" label="Pin" align="center" :filters="filters.pins" :filter-method="filterHandler" min-width="100" />
      <el-table-column
        property="dealer"
        label="Dealer"
        align="center"
        :filters="filters.dealers"
        :filter-method="filterHandler"
        min-width="200"
      />
      <el-table-column
        property="assigned_to"
        label="Assigned To"
        align="center"
        :filters="filters.staffs"
        :filter-method="filterHandler"
        min-width="180"
      />
      <el-table-column
        label="Status"
        width="100"
        property="renew_status"
        align="center"
        :filters="filters.status"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.renew_status" type="success" size="mini">Renewed</el-tag>
          <el-tag v-else-if="!scope.row.renew_status" type="danger" size="mini">Not Renewed</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="viewFarmDetails(scope.row)"
            >View Details <i class="el-icon-arrow-right el-icon-right"></i
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev, pager, next" :total="farms.items.length" :page-size="pageSize" @current-change="setPage"> </el-pagination> -->

    <!-- #region Reassign Dialog -->
    <el-dialog title="Reassign farm" :visible.sync="dialogs.reassign">
      <el-select v-model="users.selectedId" clearable placeholder="Select filed staff" size="large">
        <el-option v-for="item in users.items" :key="item.user_id" :label="item.name" :value="item.user_id">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.employee_id }}</span>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.reassign = false">Cancel</el-button>
        <el-button type="primary" @click="save()">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import axios from "axios";
import LoaderService from "../../utils/LoaderService";
import { AlertService } from "../../utils/AlertService";

export default {
  name: "FarmsList",
  computed: {
    filteredData() {
      let searchString = this.filters.searchString;
      const _array = this.farms.items.filter(function(item) {
        return (
          item.farm_id.toUpperCase().indexOf(searchString.toUpperCase()) >= 0 ||
          item.farmer_id.toUpperCase().indexOf(searchString.toUpperCase()) >= 0 ||
          item.farmer.toUpperCase().indexOf(searchString.toUpperCase()) >= 0
        );
      });
      return _array;
      // return _array.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },
    itemsShowing() {
      if (!this.isMounted) return;
      const filteredItemsLength = this.$refs.elTable.tableData.length;
      const totalItemsLength = this.farms.items.length;
      return `Showing ${filteredItemsLength} / ${totalItemsLength} Items`;
    },
  },
  watch: {
    "dialogs.reassign"(val) {
      if (!val) {
        this.users.selectedId = "";
      } else {
        if (this.farms.selectedIds.length === 0) {
          AlertService.warning(`Please select at least one farm!`);
          this.dialogs.reassign = false;
        }
      }
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 20,
      farms: {
        items: [],
        selectedIds: [],
      },
      users: {
        items: [],
        selectedId: "",
      },
      filters: {
        farmers: [],
        districts: [],
        villages: [],
        pins: [],
        staffs: [],
        dealers: [],
        variety: [],
        status: [
          { text: "Renewed", value: true },
          { text: "Not Renewed", value: false },
        ],
        searchString: "",
      },
      dialogs: {
        reassign: false,
      },
      formLabelWidth: "120px",
      isMounted: false,
    };
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    handleSelectionChange(item) {
      this.farms.selectedIds = item;
    },
    filterHandler(value, row, column) {
      return this.resolve(column["property"], row) === value;
    },
    resolve(path, obj) {
      return path.split(".").reduce(function(prev, curr) {
        return prev ? prev[curr] : null;
      }, obj || self);
    },
    setPage(val) {
      this.page = val;
    },
    async onInit() {
      LoaderService.startLoader();
      await this.getAllFarms();
      await this.getFieldStaffs();
      LoaderService.closeLoader();
    },
    async getAllFarms() {
      axios
        .get(`/farm/v2/all`)
        .then((res) => {
          this.farms.items = res.data;
          // console.log(res.data);
          this.setFilters(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFieldStaffs() {
      axios
        .get(`/user/fieldStaffs`)
        .then((res) => {
          this.users.items = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setFilters(farms) {
      this.filters.districts = [...new Set(farms.map((item) => item.district))]
        .map((item) => ({ text: item, value: item }))
        .sort((a, b) => a.text.localeCompare(b.text));
      this.filters.villages = [...new Set(farms.map((item) => item.village))]
        .map((item) => ({ text: item, value: item }))
        .sort((a, b) => a.text.localeCompare(b.text));
      this.filters.pins = [...new Set(farms.map((item) => item.pin))]
        .map((item) => ({ text: item, value: item }))
        .sort((a, b) => a.text.localeCompare(b.text));
      this.filters.staffs = [...new Set(farms.map((item) => item.assigned_to))]
        .map((item) => ({ text: item, value: item }))
        .sort((a, b) => a.text.localeCompare(b.text));
      this.filters.dealers = [...new Set(farms.map((item) => item.dealer))]
        .map((item) => ({ text: item, value: item }))
        .sort((a, b) => a.text.localeCompare(b.text));
      this.filters.variety = [...new Set(farms.map((item) => item.cultivation_variety))].map((item) => ({ text: item, value: item }));
      // .sort((a, b) => a.text.localeCompare(b.text));
    },
    viewFarmDetails(farm) {
      this.$router.push({ name: "Farms Details", params: { farm_id: farm.farm_id } });
    },
    async save() {
      try {
        await axios.patch(`/farm/reassignFarm`, {
          farm_ids: [...new Set(this.farms.selectedIds.map((item) => item.farm_id))],
          user_id: this.users.selectedId,
        });
        await this.onInit();
        AlertService.success(`Farm reassigned successfully.`);
        this.dialogs.reassign = false;
        this.$refs.elTable.clearSelection();
      } catch (error) {
        AlertService.error(error.response.data.message);
        // console.log(error.response.data.message);
      }
    },
  },
  async mounted() {
    await this.onInit();
    this.isMounted = true;
  },
};
</script>
<style lang="css" scoped>
.el-select {
  width: 450px;
}
</style>
